import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import * as IoIcons from "react-icons/io";
import img from "../Loader/spinner.gif";

function EditarUsuario({
  idUsuario,
  nombre,
  correo,

  tipo,
  institucionId,
}) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [tiposUsuario, setTiposUsuario] = useState([]);

  const [formData, setFormData] = useState({
    nombre: "",
    correo_Electronico: "",

    tipo_Usuario: "",
    rol: "",
  });

  // 🔹 Cargar datos del usuario por ID
  useEffect(() => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerUsuarioPorId?Id=${idUsuario}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((res) => {
        const user = res.data[0];
        setFormData({
          nombre: user.nombre || "",
          correo_Electronico: user.correo_Electronico || "",
          tipo_Usuario: user.tipo_Usuario || "",
          rol: user.rol || "",
        });
      })
      .catch((err) => console.error("Error al cargar usuario:", err));
  }, [idUsuario]);

  // 🔹 Cargar lista de tipos de usuario desde API
  useEffect(() => {
    axios
      .get(`https://suadesarrollo.azurewebsites.net/api/ObtenerTipoUsuario/`, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((res) => {
        setTiposUsuario(res.data);
      })
      .catch((err) => console.error("Error al cargar tipos de usuario:", err));
  }, []);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const dataToSend = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== "") dataToSend[key] = value;
    });

    if (Object.keys(dataToSend).length === 0) {
      Swal.fire("Sin cambios", "No hay campos modificados", "info");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.put(
        `https://suadesarrollo.azurewebsites.net/api/ActualizaUsuarios/actualizaUsuarios?Id=${idUsuario}`,
        dataToSend,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      );

      Swal.fire("Actualizado", response.data, "success").then(() => {
        window.location.reload("/");
      });
    } catch (error) {
      Swal.fire("Error", "Verifique los campos o intente más tarde", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button className="btn btn-warning" onClick={openModal}>
        <IoIcons.IoIosSearch />
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Editar Usuario"
      >
        <br></br> <br></br>
        <div className="container">
          <h5 className="text-center text-primary">Editar Usuario</h5>

          <form onSubmit={handleSubmit} className="user">
            <div className="form-group row">
              <div className="col-sm-6 mb-3">
                Nombre:
                <input
                  type="text"
                  name="nombre"
                  className="form-control"
                  value={formData.nombre}
                  onChange={handleChange}
                />
              </div>
              <div className="col-sm-6 mb-3">
                Correo:
                <input
                  type="email"
                  name="correo_Electronico"
                  className="form-control"
                  value={formData.correo_Electronico}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group row">
              {/* 🔽 Select de Tipo de Usuario */}
              <div className="col-sm-6 mb-3">
                Tipo de Usuario:
                <select
                  name="tipo_Usuario"
                  className="form-control"
                  value={formData.tipo_Usuario}
                  onChange={handleChange}
                >
                  <option value="">Seleccione...</option>
                  {tiposUsuario.map((tipo) => (
                    <option value={tipo.id}>{tipo.nombre}</option>
                  ))}
                </select>
              </div>
            </div>

            {!isLoading ? (
              <button type="submit" className="btn btn-primary btn-block">
                Guardar
              </button>
            ) : (
              <div className="text-center">
                <img src={img} alt="Cargando..." width={120} />
              </div>
            )}
          </form>
        </div>
      </ReactModal>
    </div>
  );
}

export default EditarUsuario;
